import { createActions, createReducer } from 'reduxsauce'

import VencedoresLicitacaoService from '../../servicos/VencedoresLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaVencedoresDetalhesLicitacaoInicio: [],
    buscaVencedoresDetalhesLicitacaoSucesso: ['vencedoresDetalhesLicitacao'],
    buscaVencedoresDetalhesLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaVencedoresDetalhesLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaVencedoresDetalhesLicitacaoInicio())
        let serv = new VencedoresLicitacaoService()
        return serv
            .consultarDetalhes(filtro)
            .then(response => dispatch(Creators.buscaVencedoresDetalhesLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaVencedoresDetalhesLicitacaoErro(error)))
    }
}

const buscaVencedoresDetalhesLicitacaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaVencedoresDetalhesLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaVencedoresDetalhesLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.vencedoresDetalhesLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_VENCEDORES_DETALHES_LICITACAO_INICIO]: buscaVencedoresDetalhesLicitacaoInicio,
    [Types.BUSCA_VENCEDORES_DETALHES_LICITACAO_ERRO]: buscaVencedoresDetalhesLicitacaoErro,
    [Types.BUSCA_VENCEDORES_DETALHES_LICITACAO_SUCESSO]: buscaVencedoresDetalhesLicitacaoSucesso,
})
